/**
 * @param v a value
 * @returns v
 **/
export const identity = <T>(v: T): T => v;
